// extracted by mini-css-extract-plugin
module.exports = {"root":"TabbedNavigation_root__37uVG","tabNavigation":"TabbedNavigation_tabNavigation__C_sJ7","panel":"TabbedNavigation_panel__u_6jX"};